<template>
  <page-header></page-header>

  <div class="innerBanner Partners-Banner position-relative">
    <div class="inBannerImg">
      <img
        src="../../assets/patnerpagebanner.png"
        alt="partners"
        class="img-fluid"
      />
    </div>
    <div class="container-sm">
      <div class="col-lg-6 col-md-6">
        <div class="innerBannerText">
          <h1 class="text-uppercase mb-3">SOLUTIONS D'AFFAIRES</h1>
          <p class="pe-4">
            Pour les entreprises de toutes tailles, ‘Postmedia Parcel Services’
            assure la livraison partout au Canada.
          </p>
          <ul class="leading_list m-0 p-0">
            <li>Livraison du dernier kilomètre</li>
            <li>Logistique « Middle Mile »</li>
            <li>Balayage et triage par induction</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="leading-edge position-relative w-100">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6 col-md-6 yellow-bg p-0">
          <div class="content-middle">
            <h2 class="text-white">
              QUI A FAIT SES PREUVES UN
              <span class="text-black">DISTRIBUTEUR</span>
            </h2>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 p-0">
          <div class="innerBannerText">
            <ul class="leading_list m-0 p-0">
              <li>
                Nous nous concentrons sur les colis et les enveloppes de 50
                livres et moins.
              </li>
              <li>Preuve de livraison</li>
              <li>Service 7 jours/semaine</li>
              <li>Services auxiliaires disponibles</li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 leading-edge-order-3">
          <div class="innerBannerText our_custom-api">
            <p class="mb-3 mt-3">
              Notre API personnalisée vous permet d'intégrer votre plateforme de
              commerce électronique directement à notre système.
            </p>
            <ul class="leading_list m-0 p-0">
              <li>
                Construit sur la meilleure solution commerciale disponible en
                vente libre.
              </li>
              <li>Capacités étendues du tableau de bord</li>
              <li>Complètement configurable</li>
              <li>Mise à jour de l'état des colis toutes les 5 minutes</li>
              <li>Technologie portable sur Android et Apple OS</li>
              <li>API ouvertes</li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 yellow-bg leading-edge-order-4">
          <div class="content-middle">
            <h2 class="text-white">
              DE POINTE <span class="text-black">TECHNOLOGIE</span>
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="Looking-for_more position-relative w-100">
    <div class="grow-business-img">
      <img
        src="../../assets/grow_business.png"
        alt="grow_business"
        class="img-fluid"
      />
    </div>
    <div class="container-sm">
      <div class="col-lg-6 col-md-6 ms-auto">
        <div class="grow-businessText">
          <h2 class="sub_heading">
            VOUS CHERCHEZ D'AUTRES MOYENS DE DÉVELOPPER VOTRE ENTREPRISE ?
          </h2>
          Postmedia Solutions est l'un des plus grands réseaux d'audience primée au Canada, offrant des solutions de publicité et de marketing aux entreprises de toutes tailles. Nous pouvons rehausser le profil de votre entreprise, vous aider à déjouer la concurrence et générer plus de pistes pour votre entreprise. Avec un portefeuille de solutions marketing imprimées et numériques, le réseau Postmedia comprend plus de 130 marques imprimées et numériques, et est visité par des millions de Canadiens chaque mois. Il fournit une plateforme inégalée d'opportunités publicitaires fiables et sûres pour les marques, et génère des données exclusives de première main qui permettent des campagnes mieux informées sur le réseau Postmedia et d'autres plateformes d'audience, y compris la recherche, les réseaux sociaux, le contenu personnalisé, l'audio numérique, le développement Web
        </div>
      </div>
    </div>
  </div>

  <div class="getInTouchSection">
    <div class="container-sm">
      <div class="getInTouch">
        <h5>
          <p>Vous avez besoin de plus d'informations ou de soutien ?</p>
          <a href="#/fr/support" title="">PRENEZ CONTACT AVEC NOUS DÈS AUJOURD'HUI !</a>
        </h5>
      </div>
    </div>
  </div>

  <page-footer></page-footer>
</template>

<script>
import PageFooter from "../fr/PageFooter.vue";
import PageHeader from "../fr/PageHeader.vue";

export default {
    beforeMount() {
    scroll(0, 0);
  },
  name: "track-your-shipment",
  components: {
    PageFooter,
    PageHeader,
  },
};
</script>